import { z } from 'zod';

/** As abas da Minha conta, na URL (`/account?tab=notificacoes`). Puro: roda no router. */
export const ACCOUNT_TABS = ['conta', 'seguranca', 'sessoes', 'notificacoes'] as const;
export type AccountTab = (typeof ACCOUNT_TABS)[number];

export const accountSearchSchema = z.object({
  tab: z.enum(ACCOUNT_TABS).optional().catch(undefined),
});
export type AccountSearch = z.infer<typeof accountSearchSchema>;
